"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireDefault(require("react"));

var _remark = _interopRequireDefault(require("remark"));

var _remarkParse = _interopRequireDefault(require("remark-parse"));

var _remarkReact = _interopRequireDefault(require("remark-react"));

var _remarkAttr = _interopRequireDefault(require("remark-attr"));

var _useFooter3 = require("../../../src/hooks/use-footer");

function Footer() {
  var _useFooter = (0, _useFooter3.useFooter)(),
      _useFooter2 = (0, _slicedToArray2["default"])(_useFooter, 1),
      node = _useFooter2[0];

  var content = node.node.frontmatter.content;
  return (
    /*#__PURE__*/
    _react["default"].createElement("footer", {
      className: "footer"
    },
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: "content has-text-centered"
    }, (0, _remark["default"])().use(_remarkParse["default"]).use(_remarkAttr["default"]).use(_remarkReact["default"]).processSync(content).contents))
  );
}

var _default = Footer;
exports["default"] = _default;